"use strict";

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var call_1 = require("./call");

var channel_1 = require("./channel");

var constants_1 = require("./constants");

var metadata_1 = require("./metadata"); // This symbol must be exported (for now).
// See: https://github.com/Microsoft/TypeScript/issues/20080


exports.kChannel = Symbol();
/**
 * A generic gRPC client. Primarily useful as a base class for all generated
 * clients.
 */

var Client =
/*#__PURE__*/
function () {
  function Client(address, credentials) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Client);

    if (options.channelOverride) {
      this[exports.kChannel] = options.channelOverride;
    } else if (options.channelFactoryOverride) {
      this[exports.kChannel] = options.channelFactoryOverride(address, credentials, options);
    } else {
      this[exports.kChannel] = new channel_1.Http2Channel(address, credentials, options);
    }
  }

  _createClass(Client, [{
    key: "close",
    value: function close() {
      this[exports.kChannel].close();
    }
  }, {
    key: "getChannel",
    value: function getChannel() {
      return this[exports.kChannel];
    }
  }, {
    key: "waitForReady",
    value: function waitForReady(deadline, callback) {
      var _this = this;

      var checkState = function checkState(err) {
        if (err) {
          callback(new Error('Failed to connect before the deadline'));
          return;
        }

        var newState;

        try {
          newState = _this[exports.kChannel].getConnectivityState(true);
        } catch (e) {
          callback(new Error('The channel has been closed'));
          return;
        }

        if (newState === channel_1.ConnectivityState.READY) {
          callback();
        } else {
          try {
            _this[exports.kChannel].watchConnectivityState(newState, deadline, checkState);
          } catch (e) {
            callback(new Error('The channel has been closed'));
          }
        }
      };

      setImmediate(checkState);
    }
  }, {
    key: "handleUnaryResponse",
    value: function handleUnaryResponse(call, deserialize, callback) {
      var responseMessage = null;
      call.on('data', function (data) {
        if (responseMessage != null) {
          call.cancelWithStatus(constants_1.Status.INTERNAL, 'Too many responses received');
        }

        try {
          responseMessage = deserialize(data);
        } catch (e) {
          call.cancelWithStatus(constants_1.Status.INTERNAL, 'Failed to parse server response');
        }
      });
      call.on('end', function () {
        if (responseMessage == null) {
          call.cancelWithStatus(constants_1.Status.INTERNAL, 'Not enough responses received');
        }
      });
      call.on('status', function (status) {
        /* We assume that call emits status after it emits end, and that it
         * accounts for any cancelWithStatus calls up until it emits status.
         * Therefore, considering the above event handlers, status.code should be
         * OK if and only if we have a non-null responseMessage */
        if (status.code === constants_1.Status.OK) {
          callback(null, responseMessage);
        } else {
          var error = Object.assign(new Error(status.details), status);
          callback(error);
        }
      });
    }
  }, {
    key: "checkOptionalUnaryResponseArguments",
    value: function checkOptionalUnaryResponseArguments(arg1, arg2, arg3) {
      if (arg1 instanceof Function) {
        return {
          metadata: new metadata_1.Metadata(),
          options: {},
          callback: arg1
        };
      } else if (arg2 instanceof Function) {
        if (arg1 instanceof metadata_1.Metadata) {
          return {
            metadata: arg1,
            options: {},
            callback: arg2
          };
        } else {
          return {
            metadata: new metadata_1.Metadata(),
            options: arg1,
            callback: arg2
          };
        }
      } else {
        if (!(arg1 instanceof metadata_1.Metadata && arg2 instanceof Object && arg3 instanceof Function)) {
          throw new Error('Incorrect arguments passed');
        }

        return {
          metadata: arg1,
          options: arg2,
          callback: arg3
        };
      }
    }
  }, {
    key: "makeUnaryRequest",
    value: function makeUnaryRequest(method, serialize, deserialize, argument, metadata, options, callback) {
      var _this$checkOptionalUn = this.checkOptionalUnaryResponseArguments(metadata, options, callback);

      metadata = _this$checkOptionalUn.metadata;
      options = _this$checkOptionalUn.options;
      callback = _this$checkOptionalUn.callback;
      var call = this[exports.kChannel].createCall(method, options.deadline, options.host, options.parent, options.propagate_flags);

      if (options.credentials) {
        call.setCredentials(options.credentials);
      }

      var message = serialize(argument);
      var writeObj = {
        message: message
      };
      call.sendMetadata(metadata);
      call.write(writeObj);
      call.end();
      this.handleUnaryResponse(call, deserialize, callback);
      return new call_1.ClientUnaryCallImpl(call);
    }
  }, {
    key: "makeClientStreamRequest",
    value: function makeClientStreamRequest(method, serialize, deserialize, metadata, options, callback) {
      var _this$checkOptionalUn2 = this.checkOptionalUnaryResponseArguments(metadata, options, callback);

      metadata = _this$checkOptionalUn2.metadata;
      options = _this$checkOptionalUn2.options;
      callback = _this$checkOptionalUn2.callback;
      var call = this[exports.kChannel].createCall(method, options.deadline, options.host, options.parent, options.propagate_flags);

      if (options.credentials) {
        call.setCredentials(options.credentials);
      }

      call.sendMetadata(metadata);
      this.handleUnaryResponse(call, deserialize, callback);
      return new call_1.ClientWritableStreamImpl(call, serialize);
    }
  }, {
    key: "checkMetadataAndOptions",
    value: function checkMetadataAndOptions(arg1, arg2) {
      var metadata;
      var options;

      if (arg1 instanceof metadata_1.Metadata) {
        metadata = arg1;

        if (arg2) {
          options = arg2;
        } else {
          options = {};
        }
      } else {
        if (arg1) {
          options = arg1;
        } else {
          options = {};
        }

        metadata = new metadata_1.Metadata();
      }

      return {
        metadata: metadata,
        options: options
      };
    }
  }, {
    key: "makeServerStreamRequest",
    value: function makeServerStreamRequest(method, serialize, deserialize, argument, metadata, options) {
      var _this$checkMetadataAn = this.checkMetadataAndOptions(metadata, options);

      metadata = _this$checkMetadataAn.metadata;
      options = _this$checkMetadataAn.options;
      var call = this[exports.kChannel].createCall(method, options.deadline, options.host, options.parent, options.propagate_flags);

      if (options.credentials) {
        call.setCredentials(options.credentials);
      }

      var message = serialize(argument);
      var writeObj = {
        message: message
      };
      call.sendMetadata(metadata);
      call.write(writeObj);
      call.end();
      return new call_1.ClientReadableStreamImpl(call, deserialize);
    }
  }, {
    key: "makeBidiStreamRequest",
    value: function makeBidiStreamRequest(method, serialize, deserialize, metadata, options) {
      var _this$checkMetadataAn2 = this.checkMetadataAndOptions(metadata, options);

      metadata = _this$checkMetadataAn2.metadata;
      options = _this$checkMetadataAn2.options;
      var call = this[exports.kChannel].createCall(method, options.deadline, options.host, options.parent, options.propagate_flags);

      if (options.credentials) {
        call.setCredentials(options.credentials);
      }

      call.sendMetadata(metadata);
      return new call_1.ClientDuplexStreamImpl(call, serialize, deserialize);
    }
  }]);

  return Client;
}();

exports.Client = Client;